import {
    AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChildren, OnDestroy,
    QueryList
} from '@angular/core';
import {TabComponent} from './tab.component';

@Component({
    selector: 'ng2-tabs',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="view-tabs">
            <ul class="view-tabs__tabs">
                <li *ngFor="let tab of showingTabs" [class.active]="tab.active" (click)="setTabActive(tab)">
                    {{tab.title}}
                </li>
            </ul>
            <div class="view-tabs__content">
                <ng-content></ng-content>
            </div>
        </div>
    `
})

export class TabsComponent implements AfterViewInit, OnDestroy {
    showingTabs = [];

    @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

    private subs = [];

    constructor(
        private cd: ChangeDetectorRef
    ) {}

    ngAfterViewInit() {
        this.updateShowingTabs();
        this.tabs.forEach(t => {
            const sub = t.changeStatus.subscribe(() => {
                this.updateShowingTabs();
            });
            this.subs.push(sub);
        });
    }

    updateShowingTabs() {
        this.showingTabs = this.tabs.filter(item => !item.hidden);
        this.cd.detectChanges();
    }

    setTabActive(tab) {
        this.tabs.forEach(t => {
            t.active = t === tab;
            t.updateView();
        });
        this.updateShowingTabs();
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
}

